
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';


export const PaySummaryRow = ({ quantity, currentPrice, totalPrice, product }) => {

    const options = { style: 'currency', currency: 'EUR' };



    return (
        <div className="card p-2 mt-1">
            <div className="row g-1 align-items-center">
                <div className="col col-lg-4 text-truncate">
                    <div className="h5 ls-1 my-auto text-truncate">{product}</div>
                </div>
                <div className="col col-lg-2 text-truncate text-right text-lg-left">
                    <div className="h5 ls-1 my-auto o-80 text-truncate">{quantity}</div>
                </div>
                <div className="col-12 d-lg-none">
                    <hr className="my-0" />
                </div>
                <div className="col col-lg-3 text-truncate text-right">
                    <div className="h5 ls-1 my-auto text-truncate">{new Intl.NumberFormat('fr-FR', options).format(currentPrice)}</div>
                </div>
                {/* <div className="col text-truncate text-right">
                    <div className="h5 ls-1 my-auto o-80 text-truncate">{new Intl.NumberFormat('fr-FR', options).format((commission * basePrice) / 100)}</div>
                </div> */}
                <div className="col text-truncate text-right">
                    <div className="h5 ls-1 my-auto text-truncate">{new Intl.NumberFormat('fr-FR', options).format(totalPrice)}</div>
                </div>
            </div>
        </div>
    );
};